// Stripe works in the smallest currency unit. Most currencies have 2 decimals; a few have none.
const ZERO_DECIMAL = new Set(["JPY", "KRW", "VND", "CLP", "UGX", "XAF", "XOF", "PYG", "RWF", "KMF", "DJF", "GNF", "MGA", "VUV", "XPF", "BIF"]);
export function toMinorUnits(amount, currency = "USD") {
  const z = ZERO_DECIMAL.has(String(currency).toUpperCase());
  return Math.round((Number(amount) || 0) * (z ? 1 : 100));
}
export function fromMinorUnits(minor, currency = "USD") {
  return ZERO_DECIMAL.has(String(currency).toUpperCase()) ? Number(minor) : Number(minor) / 100;
}
// Platform fee: a percentage plus an optional fixed part, optionally capped; never more than the payment itself.
export function platformFee(amountMinor, { percent = 1, fixedMinor = 0, capMinor = 0 } = {}) {
  let fee = Math.round(amountMinor * (percent / 100)) + (fixedMinor || 0);
  if (capMinor > 0) fee = Math.min(fee, capMinor);
  if (fee >= amountMinor) fee = 0;
  return Math.max(0, fee);
}

// Grouped number with thousands commas (1,234.50). Yen has no decimals; rupees use lakh grouping.
export function groupNum(n, currency = "USD", decimals) {
  const cur = String(currency || "USD").toUpperCase();
  const d = decimals ?? (ZERO_DECIMAL.has(cur) ? 0 : 2);
  const v = Number(n) || 0;
  try {
    return v.toLocaleString(cur === "INR" ? "en-IN" : "en-US", { minimumFractionDigits: d, maximumFractionDigits: d });
  } catch (e) { return v.toFixed(d); }
}

// On-screen money for a given currency code (the PDF uses its own ASCII-safe formatter).
export function intlMoney(currency = "USD") {
  try {
    const f = new Intl.NumberFormat(String(currency).toUpperCase() === "INR" ? "en-IN" : "en-US", { style: "currency", currency });
    return (n) => f.format(Number(n) || 0);
  } catch (e) {
    return (n) => `${currency} ${(Number(n) || 0).toFixed(2)}`;
  }
}
